import { useContext } from "react";
import { Box } from "@chakra-ui/react";
import { ArticlePreview } from "src/components/common/article-preview/article-preview";
import { FeedCardLayout } from "src/components/feed-card/common/feed-card-layout";
import { FeedCardContext } from "src/components/feed-card/feed-card";
import { FeedCardContentBlock } from "src/components/feed-card/feed-card-content-block";
import { EnumFeedClickTrackingArea, EnumFeedClickTrackingType, useFeedClickTracking } from "src/components/pages/feed/hooks/use-feed-click-tracking";
import { FeedCardActor } from "./feed-card-actor";
import { IFeedCard } from "./types/feed-card";

type TFeedCardContentProps = Pick<IFeedCard, "actor" | "articlePreview" | "content" | "displayDate">;

export const FeedCardContent = ({ content, articlePreview, actor, displayDate }: TFeedCardContentProps) => {
    const context = useContext(FeedCardContext);
    const { trackFeedClick } = useFeedClickTracking();

    const handleArticleClick = () => {
        if (articlePreview?.url) {
            trackFeedClick(context.contentId, articlePreview.url, EnumFeedClickTrackingArea.Body, EnumFeedClickTrackingType.Preview);
        }
    };

    return (
        <FeedCardLayout.Content>
            {actor && <FeedCardActor date={displayDate} {...actor} />}
            {content &&
                content.map((item, index) => (
                    <Box key={index}>
                        <FeedCardContentBlock {...item} />
                    </Box>
                ))}
            {articlePreview && <ArticlePreview size="sm" articlePreview={articlePreview} onClick={handleArticleClick} />}
        </FeedCardLayout.Content>
    );
};
